import CcpProvider from 'provider/Provider'
import { size } from 'lodash'
import session from 'core/sessionxtd'
import Logger from 'core/jsLogger'
import * as constants from 'core/constants'
import * as actions from '../src/actions'
import store from '../src/store'
import { playSound } from 'core/helpers'
import Conversation from '../src/models/Conversation'
import request from 'core/request'
import storage from 'core/storage';
import CONFIG from 'core/globals'

export let ccpProvider = {}

const cache = { setItem: session.setItem, getItem: session.getItem }

const api = {
  handlers: { cache },
  hooks: {
    onRequestError({ endpoint, statusCode, response }) {
      Logger.error(`apiError - ${endpoint || ''}`, { endpoint, statusCode, error: response })
    },
  },
}
const handlers = { cache }

const hooks = {
  onMessage: (event, data, replay = false) => {
    // debugging
    if (store.isDev) {
      console.warn(`[${event}]`, data, `replay: ${replay || false}`)
    }
    switch (event) {
      case constants.TYPING: {
        const conversation = store.conversations.find(c => c.conversationUid === data.conversationUid)
        if (conversation) {
          conversation.typingIndicator = data.showUntil
        }
        break
      }
      case constants.NEW_MESSAGE: {
        data = { ...data, replay }
        // Add message to conversation
        let conversation = store.conversations.find(c => c.conversationUid === data.conversationUid)
        if (!conversation) {
          let requestData = {userUid: CONFIG.userUid}
          request.get(ccpProvider.api.widget.endpoints.WIDGET_GET_CONVERSATIONS, requestData, [])
            .then(response => {
              if (!response.conversations) {
                return
              }
              response.conversations.forEach(receivedConversation => {
                if (store.conversations.some(conv => receivedConversation.conversationUid === conv.conversationUid)) {
                  return
                }

                receivedConversation = new Conversation(receivedConversation) //otherwise avatar fails as it cannot get the otherUserProfile relation
                store.conversations.push(receivedConversation)
                actions.chat.updateConversationCache(receivedConversation)
                if (data.conversationUid === receivedConversation.conversationUid) {
                  conversation = receivedConversation
                }
              })
            })
            .catch(error => {
              console.error('Error fetching conversations:', error)
            })
        }

        if (conversation) {
          //handle system messages first since they don't need add a message to the conversation
          if (data.type === constants.MESSAGE_TYPE_SYSTEM && data.receiverUid === conversation.meUid) {
            //Legacy, will be removed once every client is using the dedicated systemNotifications events
            if ([
              'unblock',
              'upgrade',
              'downgrade',
              'block',
              'blockRebill',
            ].includes(data.message)) {
              return
            }
          }

          // Decide whether to add the message from events to the state
          //If I am the receiver OR I'm sending the message form the legacy messaging system (!data.fromWidget):
          if (CONFIG.userUid === data.receiverUid|| (CONFIG.userUid === data.senderUid && !data.fromWidget)) {// || (CONFIG.userUid === data.senderUid && !data.fromWidget)) {
            conversation.addMessage(data)
          }
          else if (data.type === constants.MESSAGE_TYPE_CONTACT_INFO) {
            conversation.addMessage(data)
          }
          else if (data.type === constants.MESSAGE_TYPE_IMAGE) {
            conversation.addImage(data)
          }
          else if (replay) {
            conversation.addMessage(data)
          } else if (data.type === constants.MESSAGE_TYPE_SEXICON) {
            conversation.addMessage(data)
          }

          if (!replay) {
            playSound('plop')
          }

          // if(!('fromWidget' in data) || !data.fromWidget) {
          //   //user didn't use the widget to send this message, open the conversation
          //   actions.chat.setUserConversation(conversation.conversationUid)
          //   actions.widget.setWidgetState({ isOpen: true })
          // }
          if (CONFIG.userUid === data.receiverUid) {
            CONFIG.hooks.onMessageRecived?.(data)
          }
        } else {
          Logger.info(`Conversation not found: ${data.conversationUid}`)
        }
        // if(!replay && data.type === 'message') { //replaying events shouldn't cause the widget to change state
        //   actions.widget.setWidgetState({ isOpen: true })
        // }
        break
      }

      case constants.SYSTEM_NOTIFICATION: {
        const systemMessage = {
          block: () => actions.user.markUserAsBlocked(),
          blockCredit: () => actions.user.markUserAsBlocked(),
          blockRebill: () => actions.user.markUserAsBlocked(),
          contactInfoDetected: () => actions.user.contactInfoDetected(data),
          conversationLimitReached: () => {
            actions.user.markUserAsBlocked(data.type)
            actions.user.markUserAsSecondBlocked()
          },
          downgrade: () => {
            actions.user.markUserAsBlocked()
            actions.user.markUserAsFree()
          },
          unblock: () => actions.user.markUserAsUnBlocked(),
          upgrade: () => {
            actions.user.markUserAsUnBlocked()
            actions.user.markUserAsPremium()
          },
          conversationBlocked: () => {
            const conversation = store.conversations.find(c => c.conversationUid === data.conversationUid)
            if (conversation) {
              conversation.wasTempUnblocked = false
              conversation.isBlocked = true
            }
          },
          conversationLimitReset: () => {
            storage.set(`ccp-${CONFIG.userUid}-blocked-conversations`, []);
          },
        }
        if (systemMessage[data.type]) {
          systemMessage[data.type](data)
          actions.user.updateUserCache()
        }
        break
      }

      case constants.NEW_CONVERSATION: {
        const conv = actions.chat.addConversation(data, true)
        if (store.conversations.find(c => c.conversationUid === data.conversationUid)) {
          if (data.forceFocus) {
            conv.fetchMessages()
            actions.widget.setWidgetState({ isOpen: true })
            actions.chat.setUserConversation(data.conversationUid)
          }
          return
        }
        if (size(store.conversations) === 1) {
          actions.chat.setUserConversation(data.conversationUid)
        }
        conv.fetchMessages()
        if (data.startedBy === conv.meIndex) {
          if (!replay) { //replaying events shouldn't cause the widget to change state
            actions.widget.setWidgetState({ isOpen: true })
          }
          actions.chat.setUserConversation(conv.conversationUid)
        }

        // conv.fetchPictures(conv.otherUserUid)
        break
      }

      case constants.NEW_ALERT: {
        if (data.receiverUid !== CONFIG.userUid) {
          break
        }
        if (data.type === constants.MESSAGE_TYPE_UPGRADE) {
          store.user.secondBlock = true
        } else {
          store.conversations.forEach(conv => {
            conv.addMessage(data)
          })
        }
        break
      }

      case constants.CONVERSATION_DELETED: {
        actions.chat.deleteConversation(data)
        break
      }

      case constants.UPGRADE_REDIRECT: {
        if (data.receiverUid === CONFIG.userUid) {
          let conversation = store.conversations.find(c => c.conversationUid === data.conversationUid)
          if (conversation) {
            conversation.userInteracted()
          }
          window.location.href = CONFIG.urls.upgrade(data.userProfile || store.conversation.otherUserProfile)
        }
        break
      }

      case constants.RE_AUTH: {
        store.socket.connect()
        break
      }

      case constants.RECURRING_UPDATED: {
        const { features = {} } = window.CONFIG
        if (features.showRecurringNotification) {
          actions.user.toggleRecurringBlock(data.enabled)
        }
        break
      }

      default:
        return
    }
  },
}

export const initProvider = options => {
  ccpProvider =  new CcpProvider({
    config: {
      api: options.api,
      token: options.userToken,
      identifier: options.identifier,
      safeMode: options.safeMode || false,
    },
    websocketConfig: {
      clientId: options.userUid,
      ...options?.websocketConfig || {},
    },
  }, true)

  ccpProvider.handlers = handlers
  ccpProvider.hooks = hooks
  ccpProvider.api.handlers = api.handlers
  ccpProvider.api.hooks = api.hooks

  return ccpProvider
}
